import * as React from 'react';
import { FC } from 'react';

import { maybeLocale } from 'utils/graphql';

import { StyledPicture } from './styled';
import { IItemPictureProps } from './types';

export const OfferItemPicture: FC<IItemPictureProps<'offer'>> = ({
  entryCartDetails: { offer },
  ...props
}) => (
  <StyledPicture
    {...props}
    alt={offer?.localizedImage?.locale?.imageDescription || ''}
    image={offer?.localizedImage?.locale?.app}
  />
);

export const RewardItemPicture: FC<React.PropsWithChildren<IItemPictureProps<'reward'>>> = ({
  entryCartDetails: { reward },
  ...props
}) => (
  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  <StyledPicture {...props} alt={reward?.name?.en || ''} image={maybeLocale(reward.image)} />
);
